/** 对象数组：`value` 为识别/存储用地区码，`text` 为语音识别服务文案的 i18n 键 */
export const ORIGINAL_LANGUAGE_LIST = [
    {
        value: 'af-ZA',
        text: 'af-za-speech-service',
    },
    {
        value: 'sq-AL',
        text: 'sq-al-speech-service',
    },
    {
        value: 'am-ET',
        text: 'am-et-speech-service',
    },
    {
        value: 'ar-DZ',
        text: 'ar-dz-speech-service',
    },
    {
        value: 'ar-BH',
        text: 'ar-bh-speech-service',
    },
    {
        value: 'ar-EG',
        text: 'ar-eg-speech-service',
    },
    {
        value: 'ar-IQ',
        text: 'ar-iq-speech-service',
    },
    {
        value: 'ar-IL',
        text: 'ar-il-speech-service',
    },
    {
        value: 'ar-JO',
        text: 'ar-jo-speech-service',
    },
    {
        value: 'ar-KW',
        text: 'ar-kw-speech-service',
    },
    {
        value: 'ar-LB',
        text: 'ar-lb-speech-service',
    },
    {
        value: 'ar-LY',
        text: 'ar-ly-speech-service',
    },
    {
        value: 'ar-MA',
        text: 'ar-ma-speech-service',
    },
    {
        value: 'ar-OM',
        text: 'ar-om-speech-service',
    },
    {
        value: 'ar-PS',
        text: 'ar-ps-speech-service',
    },
    {
        value: 'ar-QA',
        text: 'ar-qa-speech-service',
    },
    {
        value: 'ar-SA',
        text: 'ar-sa-speech-service',
    },
    {
        value: 'ar-SY',
        text: 'ar-sy-speech-service',
    },
    {
        value: 'ar-TN',
        text: 'ar-tn-speech-service',
    },
    {
        value: 'ar-AE',
        text: 'ar-ae-speech-service',
    },
    {
        value: 'ar-YE',
        text: 'ar-ye-speech-service',
    },
    {
        value: 'hy-AM',
        text: 'hy-am-speech-service',
    },
    {
        value: 'az-AZ',
        text: 'az-az-speech-service',
    },
    {
        value: 'eu-ES',
        text: 'eu-es-speech-service',
    },
    {
        value: 'bn-IN',
        text: 'bn-in-speech-service',
    },
    {
        value: 'bs-BA',
        text: 'bs-ba-speech-service',
    },
    {
        value: 'bg-BG',
        text: 'bg-bg-speech-service',
    },
    {
        value: 'my-MM',
        text: 'my-mm-speech-service',
    },
    {
        value: 'ca-ES',
        text: 'ca-es-speech-service',
    },
    {
        value: 'yue-CN',
        text: 'yue-cn-speech-service',
    },
    {
        value: 'zh-HK',
        text: 'zh-hk-speech-service',
    },
    {
        value: 'zh-CN',
        text: 'zh-cn-speech-service',
    },
    {
        value: 'zh-CN-SICHUAN',
        text: 'zh-cn-sichuan-speech-service',
    },
    {
        value: 'zh-TW',
        text: 'zh-tw-speech-service',
    },
    {
        value: 'wuu-CN',
        text: 'wuu-cn-speech-service',
    },
    {
        value: 'hr-HR',
        text: 'hr-hr-speech-service',
    },
    {
        value: 'cs-CZ',
        text: 'cs-cz-speech-service',
    },
    {
        value: 'da-DK',
        text: 'da-dk-speech-service',
    },
    {
        value: 'nl-BE',
        text: 'nl-be-speech-service',
    },
    {
        value: 'nl-NL',
        text: 'nl-nl-speech-service',
    },
    {
        value: 'en-AU',
        text: 'en-au-speech-service',
    },
    {
        value: 'en-CA',
        text: 'en-ca-speech-service',
    },
    {
        value: 'en-GH',
        text: 'en-gh-speech-service',
    },
    {
        value: 'en-HK',
        text: 'en-hk-speech-service',
    },
    {
        value: 'en-IN',
        text: 'en-in-speech-service',
    },
    {
        value: 'en-IE',
        text: 'en-ie-speech-service',
    },
    {
        value: 'en-KE',
        text: 'en-ke-speech-service',
    },
    {
        value: 'en-NZ',
        text: 'en-nz-speech-service',
    },
    {
        value: 'en-NG',
        text: 'en-ng-speech-service',
    },
    {
        value: 'en-PH',
        text: 'en-ph-speech-service',
    },
    {
        value: 'en-SG',
        text: 'en-sg-speech-service',
    },
    {
        value: 'en-ZA',
        text: 'en-za-speech-service',
    },
    {
        value: 'en-TZ',
        text: 'en-tz-speech-service',
    },
    {
        value: 'en-GB',
        text: 'en-gb-speech-service',
    },
    {
        value: 'en-US',
        text: 'en-us-speech-service',
    },
    {
        value: 'et-EE',
        text: 'et-ee-speech-service',
    },
    {
        value: 'fil-PH',
        text: 'fil-ph-speech-service',
    },
    {
        value: 'fi-FI',
        text: 'fi-fi-speech-service',
    },
    {
        value: 'fr-BE',
        text: 'fr-be-speech-service',
    },
    {
        value: 'fr-CA',
        text: 'fr-ca-speech-service',
    },
    {
        value: 'fr-FR',
        text: 'fr-fr-speech-service',
    },
    {
        value: 'fr-CH',
        text: 'fr-ch-speech-service',
    },
    {
        value: 'gl-ES',
        text: 'gl-es-speech-service',
    },
    {
        value: 'ka-GE',
        text: 'ka-ge-speech-service',
    },
    {
        value: 'de-AT',
        text: 'de-at-speech-service',
    },
    {
        value: 'de-DE',
        text: 'de-de-speech-service',
    },
    {
        value: 'de-CH',
        text: 'de-ch-speech-service',
    },
    {
        value: 'el-GR',
        text: 'el-gr-speech-service',
    },
    {
        value: 'gu-IN',
        text: 'gu-in-speech-service',
    },
    {
        value: 'he-IL',
        text: 'he-il-speech-service',
    },
    {
        value: 'hi-IN',
        text: 'hi-in-speech-service',
    },
    {
        value: 'hu-HU',
        text: 'hu-hu-speech-service',
    },
    {
        value: 'is-IS',
        text: 'is-is-speech-service',
    },
    {
        value: 'id-ID',
        text: 'id-id-speech-service',
    },
    {
        value: 'ga-IE',
        text: 'ga-ie-speech-service',
    },
    {
        value: 'it-IT',
        text: 'it-it-speech-service',
    },
    {
        value: 'it-CH',
        text: 'it-ch-speech-service',
    },
    {
        value: 'ja-JP',
        text: 'ja-jp-speech-service',
    },
    {
        value: 'jv-ID',
        text: 'jv-id-speech-service',
    },
    {
        value: 'kn-IN',
        text: 'kn-in-speech-service',
    },
    {
        value: 'kk-KZ',
        text: 'kk-kz-speech-service',
    },
    {
        value: 'km-KH',
        text: 'km-kh-speech-service',
    },
    {
        value: 'ko-KR',
        text: 'ko-kr-speech-service',
    },
    {
        value: 'lo-LA',
        text: 'lo-la-speech-service',
    },
    {
        value: 'lv-LV',
        text: 'lv-lv-speech-service',
    },
    {
        value: 'lt-LT',
        text: 'lt-lt-speech-service',
    },
    {
        value: 'mk-MK',
        text: 'mk-mk-speech-service',
    },
    {
        value: 'ms-MY',
        text: 'ms-my-speech-service',
    },
    {
        value: 'ml-IN',
        text: 'ml-in-speech-service',
    },
    {
        value: 'mt-MT',
        text: 'mt-mt-speech-service',
    },
    {
        value: 'mr-IN',
        text: 'mr-in-speech-service',
    },
    {
        value: 'mn-MN',
        text: 'mn-mn-speech-service',
    },
    {
        value: 'ne-NP',
        text: 'ne-np-speech-service',
    },
    {
        value: 'nb-NO',
        text: 'nb-no-speech-service',
    },
    {
        value: 'ps-AF',
        text: 'ps-af-speech-service',
    },
    {
        value: 'fa-IR',
        text: 'fa-ir-speech-service',
    },
    {
        value: 'pl-PL',
        text: 'pl-pl-speech-service',
    },
    {
        value: 'pt-BR',
        text: 'pt-br-speech-service',
    },
    {
        value: 'pt-PT',
        text: 'pt-pt-speech-service',
    },
    {
        value: 'ro-RO',
        text: 'ro-ro-speech-service',
    },
    {
        value: 'ru-RU',
        text: 'ru-ru-speech-service',
    },
    {
        value: 'sr-RS',
        text: 'sr-rs-speech-service',
    },
    {
        value: 'si-LK',
        text: 'si-lk-speech-service',
    },
    {
        value: 'sk-SK',
        text: 'sk-sk-speech-service',
    },
    {
        value: 'sl-SI',
        text: 'sl-si-speech-service',
    },
    {
        value: 'so-SO',
        text: 'so-so-speech-service',
    },
    {
        value: 'es-AR',
        text: 'es-ar-speech-service',
    },
    {
        value: 'es-BO',
        text: 'es-bo-speech-service',
    },
    {
        value: 'es-CL',
        text: 'es-cl-speech-service',
    },
    {
        value: 'es-CO',
        text: 'es-co-speech-service',
    },
    {
        value: 'es-CR',
        text: 'es-cr-speech-service',
    },
    {
        value: 'es-CU',
        text: 'es-cu-speech-service',
    },
    {
        value: 'es-DO',
        text: 'es-do-speech-service',
    },
    {
        value: 'es-EC',
        text: 'es-ec-speech-service',
    },
    {
        value: 'es-SV',
        text: 'es-sv-speech-service',
    },
    {
        value: 'es-GQ',
        text: 'es-gq-speech-service',
    },
    {
        value: 'es-GT',
        text: 'es-gt-speech-service',
    },
    {
        value: 'es-HN',
        text: 'es-hn-speech-service',
    },
    {
        value: 'es-MX',
        text: 'es-mx-speech-service',
    },
    {
        value: 'es-NI',
        text: 'es-ni-speech-service',
    },
    {
        value: 'es-PA',
        text: 'es-pa-speech-service',
    },
    {
        value: 'es-PY',
        text: 'es-py-speech-service',
    },
    {
        value: 'es-PE',
        text: 'es-pe-speech-service',
    },
    {
        value: 'es-PR',
        text: 'es-pr-speech-service',
    },
    {
        value: 'es-ES',
        text: 'es-es-speech-service',
    },
    {
        value: 'es-US',
        text: 'es-us-speech-service',
    },
    {
        value: 'es-UY',
        text: 'es-uy-speech-service',
    },
    {
        value: 'es-VE',
        text: 'es-ve-speech-service',
    },
    {
        value: 'sw-KE',
        text: 'sw-ke-speech-service',
    },
    {
        value: 'sw-TZ',
        text: 'sw-tz-speech-service',
    },
    {
        value: 'sv-SE',
        text: 'sv-se-speech-service',
    },
    {
        value: 'ta-IN',
        text: 'ta-in-speech-service',
    },
    {
        value: 'te-IN',
        text: 'te-in-speech-service',
    },
    {
        value: 'th-TH',
        text: 'th-th-speech-service',
    },
    {
        value: 'tr-TR',
        text: 'tr-tr-speech-service',
    },
    {
        value: 'uk-UA',
        text: 'uk-ua-speech-service',
    },
    {
        value: 'uz-UZ',
        text: 'uz-uz-speech-service',
    },
    {
        value: 'vi-VN',
        text: 'vi-vn-speech-service',
    },
    {
        value: 'cy-GB',
        text: 'cy-gb-speech-service',
    },
    {
        value: 'zu-ZA',
        text: 'zu-za-speech-service',
    },
];
/** 字符串数组：存参与展示相同 */
export const TARGET_LANGUAGE_LIST = [
    { value: 'en-US', text: 'English' },
    { value: 'es-MX', text: 'Español' },
    { value: 'pt-BR', text: 'Português' },
    { value: 'de-DE', text: 'Deutsch' },
    { value: 'fr-FR', text: 'Français' },
    { value: 'ja-JP', text: '日本語' },
    { value: 'zh-TW', text: '繁體中文' },
    { value: 'zh-CN', text: '简体中文' },
    { value: 'ar-SA', text: 'اللغة العربية' },
    { value: 'id-ID', text: 'Bahasa Indonesia' },
    { value: 'it-IT', text: 'Italiano' },
    { value: 'nl-NL', text: 'Nederlands' },
    { value: 'pl-PL', text: 'Polski' },
    { value: 'tr-TR', text: 'Türkçe' },
    { value: 'ru-RU', text: 'Русский' },
    { value: 'hi-IN', text: 'हिन्दी' },
    { value: 'cs-CZ', text: 'Čeština' },
    { value: 'ro-RO', text: 'Română' },
] as const;

export type TargetLanguageValue = (typeof TARGET_LANGUAGE_LIST)[number]['value'];

/** 原音语言默认英语（与 `ORIGINAL_LANGUAGE_LIST` 中 `en-US` 一致） */
export const DEFAULT_ORIGINAL_LANGUAGE_KEY = 'en-US';

/**
 * 根据当前 UI locale（如 `FJLocalStore.currentTag()`）返回 `TARGET_LANGUAGE_LIST` 的 `value`；
 * 未命中时返回 `english`。
 */
export function getDefaultTextLanguageKeyForLocale(localeTag: string): TargetLanguageValue {
    const map: Record<string, TargetLanguageValue> = {
        cn: 'zh-CN',
        tw: 'zh-TW',
        jp: 'ja-JP',
        fr: 'fr-FR',
        de: 'de-DE',
        es: 'es-MX',
        pt: 'pt-BR',
        ar: 'ar-SA',
        en: 'en-US',
    };
    return map[localeTag] ?? 'english';
}
/** 对象数组：`value` 写入状态与接口，`text` 为 `FJLocalStore._` 键名 */
export const GENRE_LIST = [
    { value: 'auto', text: 'auto' },
    { value: 'highlight_collection', text: 'highlights' },
    { value: 'golden_quotes', text: 'key-points' },
    { value: 'qa_split', text: 'qa-clips' },
    { value: 'tutorial_steps', text: 'tutorial-steps' },
    { value: 'product_highlights', text: 'product-features' },
];
/** 对象数组：`value` 写入状态与接口，`text` 为时长选项文案的 i18n 键 */
export type FJDurationListItem = {
    value: string;
    text: string;
    /** 源视频时长（秒）低于该值时，生成设置里该选项置灰不可选 */
    minSourceDurationSec?: number;
};

export const DURATION_LIST: FJDurationListItem[] = [
    {
        value: 'auto',
        text: 'auto',
    },
    {
        value: '[0,30]',
        text: '<30s',
        minSourceDurationSec: 0,
    },
    {
        value: '[30,60]',
        text: '30-60s',
        minSourceDurationSec: 30,
    },
    {
        value: '[60,90]',
        text: '60-90s',
        minSourceDurationSec: 60,
    },
    {
        value: '[90,180]',
        text: '90-180s',
        minSourceDurationSec: 90,
    },
];
/** 字符串数组：存参与展示相同，选项 `value` / `label` 均用该字符串 */
export const RATIO_LIST = ['9:16', '16:9', '1:1', '4:5', '3:4'];
